document.addEventListener('click', function (event) {
	if (event.target.closest('.cart-toggle') || event.target.closest('.ajax-cart-overlay')) {
    event.preventDefault();
    document.querySelector('.ajax-cart').classList.toggle('open');
  }
  if (event.target == document.querySelector('.spr-form')) {
    event.preventDefault();
    document.querySelector('.spr-form').style.display = "none";
  }
  if (event.target == document.querySelector('.spr-summary-actions-newreview')) {
    let reviewForm = document.querySelector('.new-review-form');
    let id = document.querySelector('#shopify-product-reviews').getAttribute('data-id'); 
    if (reviewForm) {
      reviewForm.innerHTML = '<button class="position-absolute top-0 end-0 m-1 btn-close" onclick="SPR.toggleForm('+ id +');return false"><span class="sr-only">Close Review Modal</span></button>' + reviewForm.innerHTML
    }
  }
  if (event.target.matches('.type-toggle')) {
		event.preventDefault();
		let el = event.target;
		let id = el.getAttribute("data-product-id");
		let variant_id = el.getAttribute("data-variant-id");

		for(let sib of el.parentElement.children) {
			sib.classList.remove('active')
		}

		el.classList.add('active');
		document.querySelector('#product-select-'+id).value = variant_id;
		document.querySelector('.product-form-'+id).classList.remove('d-none');
	}
  
  return;
}, false);

function updateCart (cart, cart2) {
  toggleCartLoader(true);
  var formData = [];
  var formDataAttr = {};

  for (let index = 0; index < cart.elements.length; index++) {
    const element = cart.elements[index];
    if (element.name == 'updates[]') {
      formData.push(parseInt(element.value));
    }
    if (element.name == 'attributes[Non-Profit Choice]') {
      formDataAttr = {'Non-Profit Choice':element.value};
    }
  }
  formDataJSON = {
    updates: formData,
    attributes: formDataAttr
  };
  console.log(JSON.stringify(formDataJSON));
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formDataJSON),
  }).then(function(){
    fetch('/cart?view=ajax').then(function (response) {
      return response.text();
    }).then(function (html) {
      var parser = new DOMParser();
      var cartHTML = parser.parseFromString(html, 'text/html');
      cart.innerHTML = cartHTML.querySelector('body').innerHTML;
      if (cart2) {
        cart2.innerHTML = cartHTML.querySelector('body').innerHTML;
      }
      bindQuantityFields();
      toggleCartLoader(true);
      
      // Check if cart is empty and clear attributes if needed
      clearCartAttributesIfEmpty();
    })
    .finally(() => {
      toggleCartLoader(false);
      setTimeout(checkAndApplyBuyXGetY, 10);
    });
  })
  .catch(function(error) { 
    console.warn('Something went wrong.', error);
  });
}

function bindQuantityFields() {
  document.querySelectorAll('.quantity-container').forEach(container => {
    const input = container.querySelector('.quantity-amount');
    const decrease = container.querySelector('.quantity-decrease');
    const increase = container.querySelector('.quantity-increase');
    const cartRow = container.closest('.cart-row-item'); // Get parent cart row

    function updateQuantity(change) {
      let newValue = parseInt(input.value) + change;
      if (newValue < 1) newValue = 0; // Prevent going below 1
      input.value = newValue;
      

      // Check if this item has bundled child products
      if (cartRow.hasAttribute('data-bundle-product')) {
        const childVariantIds = JSON.parse(cartRow.getAttribute('data-bundle-product'));

        childVariantIds.forEach(variantId => {
          const childRow = document.querySelector(`.cart-row-item[data-id="${variantId}"]`);
          if (childRow) {
            const childInput = childRow.querySelector('.quantity-amount');
            if (childInput) {
              childInput.value = newValue;
              setTimeout(() => {
                childInput.closest('form').dispatchEvent(new Event('change'));
              }, 100);
            }
          }
        });
      } else{
        input.closest('form').dispatchEvent(new Event('change'));
      }
    }

    decrease.addEventListener('click', () => updateQuantity(-1));
    increase.addEventListener('click', () => updateQuantity(1));
  });
}

function toggleCartLoader(show = true) {
  var el = document.querySelector('.cart-loader');
  var checkoutButton = document.querySelector('.display-main-cart button[name="checkout"]');

  if (el) {
    el.style.display = show ? "flex" : "none";
  }

  if (checkoutButton) {
    checkoutButton.disabled = show;
  }

}



function debounce(func, wait, immediate) {
  var timeout;
  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

function predictive_search() {
  var input = document.querySelector('#q');
  const predictiveSearchSection = document.querySelector('#predictive-results');
  var requestResponse;
  //on keyup, start the countdown
  input.addEventListener('input', debounce((event) => {
    predictiveSearchSection.style.display = 'block';
    predictiveSearchSection.innerHTML = '<div class="mx-auto my-3 text-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
    var search_term = input.value;
    if (input.value != '') {
      fetch('/search/suggest?q='+search_term+'&resources[type]=product,collection,article,page&resources[limit]=4&section_id=site-predictive-search').then((response) => {
        requestResponse = response;
        return response.text();
       })
      .then((text) => {
        if (!requestResponse.ok) {
          console.error(requestResponse.status + ': ' + text);
        }
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-site-predictive-search').innerHTML;
        predictiveSearchSection.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        toggleCartLoader(false);
      });
    } else {
      predictiveSearchSection.style.display = 'none';
    }
  }, 500));
};

function addProductToCart(e) {
  e.preventDefault();
  toggleCartLoader(true);

  // Use the form that triggered the event
  let addToCartForm = e.target;
  let formData = new FormData(addToCartForm);

  let products = [];
  let attributes = {};

  // Collect cart attributes
  addToCartForm.querySelectorAll('select[name^="attributes"], input[name^="attributes"]').forEach((input) => {
    if (input.value) {
      let attributeName = input.name.replace('attributes[', '').replace(']', '');
      attributes[attributeName] = input.value;
    }
  });

  // Helper function to collect properties
  function getProperties(container, excludeAdditional = false) {
    let properties = {};
    container.querySelectorAll('input[name^="properties"]').forEach((input) => {
      // Skip properties inside .additional-products if excludeAdditional is true
      if (excludeAdditional && input.closest('.additional-products')) return;

      if (input.value) {
        properties[input.name.replace('properties[', '').replace(']', '')] = input.value;
      }
    });
    return properties;
  }

  // Add main product with properties and selling plan
  products.push({
    id: formData.get('id'),
    quantity: formData.get('quantity') || 1,
    selling_plan: formData.get('selling_plan') || null,
    properties: getProperties(addToCartForm, true)
  });

  
  // Check for additional products
  addToCartForm.querySelectorAll('select[data-additional-products]').forEach((additionalSelect) => {
    let selectedOption = additionalSelect.options[additionalSelect.selectedIndex];
    let variantId = selectedOption.getAttribute('data-id');
    let sellingPlanInput = additionalSelect.closest('.additional-product-item').querySelector('[name="selling_plan"]');
    let sellingPlan = sellingPlanInput ? sellingPlanInput.value : null;
    if (variantId) {
      products.push({
        id: variantId,
        quantity: formData.get('quantity') || 1,
        selling_plan: sellingPlan,
        properties: getProperties(additionalSelect.closest('.additional-product-item'))  // Collect properties for each additional item
      });
    }
  });
  
  console.log('products', products);
  // Submit all products to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: products })
  }).then(() => {
    // If we have attributes, update the cart with them
    if (Object.keys(attributes).length > 0) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      });
    }
  }).then(() => {
    refreshCart();
    setTimeout(checkAndApplyBuyXGetY, 300);
  }).catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    toggleCartLoader(false);
  });
}



function refreshCart() {
  toggleCartLoader(true); // Show loader before fetching
  fetch('/cart?view=ajax').then(function (response) {
    return response.text();
  }).then(function (html) {
    var parser = new DOMParser();
    var cartHTML = parser.parseFromString(html, 'text/html');
    var cart_ajax = document.querySelector('#cart-main-ajax');
    cart_ajax.innerHTML = cartHTML.querySelector('body').innerHTML;
    bindQuantityFields();
    setTimeout(reloadShoppingGivesWidget, 100);
    
    // Check if cart is empty and clear attributes if needed
    clearCartAttributesIfEmpty();
  })
  .catch(error => console.warn('Something went wrong.', error))
  .finally(() => toggleCartLoader(false)); // Hide loader after completion

  const ajaxCart = document.querySelector('.ajax-cart');
  if (!ajaxCart.classList.contains('open')) {
    ajaxCart.classList.add('open');
  }

  //toggleCartLoader();
}

function checkAndApplyBuyXGetY() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let xProductQuantities = {}; // Track X product quantities
      let yProductsToUpdate = [];
      let yProductsToRemove = [];

      // Step 1: Count X products in the cart
      cart.items.forEach(cartItem => {
        let matchedPair = window.buyXGetYProducts.find(pair => pair.X == cartItem.product_id);
        if (matchedPair) {
          xProductQuantities[cartItem.product_id] = (xProductQuantities[cartItem.product_id] || 0) + cartItem.quantity;
        }
      });

      // Step 2: Validate existing Y products in the cart
      cart.items.forEach(cartItem => {
        let freeItemFor = cartItem.properties && cartItem.properties._free_item_for;

        if (freeItemFor) {
          let requiredQty = xProductQuantities[freeItemFor] || 0;

          if (requiredQty === 0) {
            // X product is missing, remove this Y product
            yProductsToRemove.push(cartItem.key);
          } else if (cartItem.quantity !== requiredQty) {
            // X exists but quantity mismatch, update Y quantity
            yProductsToUpdate.push({ key: cartItem.key, quantity: requiredQty });
          }

          // Remove this from tracking so we don't add it again
          delete xProductQuantities[freeItemFor];
        }
      });

      // Step 3: Add missing Y products
      let itemsToAdd = [];
      Object.keys(xProductQuantities).forEach(xProductId => {
        let matchedPair = window.buyXGetYProducts.find(pair => pair.X == xProductId);
        if (matchedPair) {
          itemsToAdd.push({
            id: matchedPair.Y,
            quantity: xProductQuantities[xProductId],
            properties: { _free_item_for: xProductId }
          });
        }
      });

      // Step 4: Apply cart changes
      if (yProductsToRemove.length > 0) removeCartItems(yProductsToRemove);
      if (yProductsToUpdate.length > 0) updateCartItemQuantities(yProductsToUpdate);
      if (itemsToAdd.length > 0) addFreeProducts(itemsToAdd);
    })
    .catch(error => console.error("Error fetching cart:", error));
}

// Function to update Y product quantities
function updateCartItemQuantities(items) {
  let promises = items.map(item =>
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: item.quantity })
    })
  );

  Promise.all(promises).then(() => refreshCart()).catch(error => console.error('Error updating cart:', error));
}

// Function to remove Y products
function removeCartItems(keys) {
  let promises = keys.map(key =>
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
  );

  Promise.all(promises)
    .then(() => {
      clearCartAttributesIfEmpty(); // Check if cart is now empty
      refreshCart();
    })
    .catch(error => console.error('Error removing items:', error));
}

// Function to add free products with properties
function addFreeProducts(products) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: products })
  }).then(() => refreshCart()).catch(error => console.error('Error adding free products:', error));
}

var scrollPos = 0;
function reveal() {
  var reveals = document.querySelectorAll(".reveal");
  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 20;
    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active");
    } else {
      reveals[i].classList.remove("active");
    }
  }
  if (scrollPos < -20) {
    document.querySelector('.shopify-section-group-site-header-group.header').classList.add('scrolled');
  }
  if (scrollPos < -50) {
    if ((document.body.getBoundingClientRect()).top > scrollPos) {
      document.querySelector('.shopify-section-group-site-header-group.header').classList.add('scroll-up');
    } else {
      document.querySelector('.shopify-section-group-site-header-group.header').classList.remove('scroll-up');
    }
  } else {
    document.querySelector('.shopify-section-group-site-header-group.header').classList.remove('scroll-up');
  }
  scrollPos = (document.body.getBoundingClientRect()).top;
  //console.log(scrollPos);
}

window.addEventListener("scroll", reveal);

function editSellingPlan (index, selling_plan) {
  console.log('Index:', index);
  console.log('Selected selling plan:', selling_plan);
  toggleCartLoader(true);
  fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({'line': index, 'selling_plan': selling_plan }),
  }).then(function(){
    console.log('selling plan updated');
    refreshCart();
    const ajaxCart = document.querySelector('.ajax-cart');
    if (!ajaxCart.classList.contains('open')) {
      ajaxCart.classList.add('open');
    }
    setTimeout(checkAndApplyBuyXGetY, 300);
  })
  .catch(function(error) { 
    console.warn('Something went wrong.', error);
  });
}

function reloadShoppingGivesWidget() {
  var widgetContainer = document.getElementById('shopping-gives-cart-script');
  var script = widgetContainer.getElementsByTagName('script');
  console.log(script);
  var oldScript = script[0].getAttribute("src");
  script[0].remove();
  var newScript;
  newScript = document.createElement('script');
  newScript.type = 'text/javascript';
  newScript.src = oldScript;
  widgetContainer.appendChild(newScript);
  console.log('Script refreshed');
}

// Add this function to clear cart attributes when cart is empty
function clearCartAttributesIfEmpty() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.item_count === 0) {
        // Cart is empty, clear all attributes
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ attributes: { 'Foundation': '' } })
        }).then(() => {
          console.log('Cart attributes cleared because cart is empty');
        });
      }
    })
    .catch(error => console.error("Error fetching cart:", error));
}

window.addEventListener("load", function () {
  bindQuantityFields();
  predictive_search();

  var cart = document.querySelector('#cart-main');
  var cart_ajax = document.querySelector('#cart-main-ajax');
  if (cart) {
    document.querySelector('#cart-main').addEventListener('change', function(event){
      console.log(event);
      if (event.target.name == 'cart-selling-plan' ) {
        console.log('Change Selling plan');
        editSellingPlan(event.target.getAttribute('data-index'), event.target.value); // index and selling plan id
      } else if (event.target.name == 'selling-plan-toggle') {
        console.log('Selling plan toggle');
        if (event.target.checked == true) {
          editSellingPlan(event.target.getAttribute('data-index'), event.target.value);
        } else {
          editSellingPlan(event.target.getAttribute('data-index'), null);
        }
      } else {
        console.log('Regular cart update');
        updateCart(this, cart_ajax);
      }
    });
  }
  if (cart_ajax) {
    document.querySelector('#cart-main-ajax').addEventListener('change', function(event){
      console.log(event);
      if (event.target.name == 'cart-selling-plan' ) {
        console.log('Change Selling plan');
        editSellingPlan(event.target.getAttribute('data-index'), event.target.value); // index and selling plan id
      } else if (event.target.name == 'selling-plan-toggle') {
        console.log('Selling plan toggle');
        if (event.target.checked == true) {
          editSellingPlan(event.target.getAttribute('data-index'), event.target.value);
        } else {
          editSellingPlan(event.target.getAttribute('data-index'), null);
        }
      } else {
        console.log('Regular cart update');
        updateCart(this, cart);
      }
    });
  }

  // Get all add to cart forms and attach event listeners to each
  let addToCartForms = document.querySelectorAll('form[action$="/cart/add"]');
  if (addToCartForms.length > 0) {
    addToCartForms.forEach(form => {
      if (form.attachEvent) {
        form.attachEvent("submit", addProductToCart);
      } else {
        form.addEventListener("submit", addProductToCart);
      }
    });
  }

  reveal();
});